import { cn } from '@/lib/utils'

/**
 * Consistent visual frame for every step in the visit form.
 * Renders an eyebrow, title, optional description and the form body.
 */
export function StepShell({ eyebrow, title, description, children, className }) {
  return (
    <div className={cn('animate-slide-up', className)}>
      <div className="mb-6">
        {eyebrow && (
          <p className="mb-1 text-[10px] font-bold uppercase tracking-[0.14em] text-accent-600">
            {eyebrow}
          </p>
        )}
        <h2 className="h-display text-2xl font-bold text-ink-900 sm:text-3xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm text-ink-500 sm:text-[15px]">
            {description}
          </p>
        )}
      </div>
      <div className="space-y-5">{children}</div>
    </div>
  )
}

/**
 * 2-column responsive grid used inside steps.
 */
export function StepGrid({ children, className }) {
  return (
    <div className={cn('grid gap-4 sm:grid-cols-2', className)}>{children}</div>
  )
}
